import { cn } from '@/lib/utils'
import {
  BaseLink,
  Chip,
  Icon,
  Img,
  Title,
  TourBadge,
  TourInfo
} from '@/ui/components'
import { memo } from 'react'
import { SectionSliderItem } from './type'

const SectionSliderCard = ({
  link,
  image,
  chipContent,
  title,
  tourInfo
}: SectionSliderItem) => (
  <BaseLink
    href={link?.href || ''}
    target={link?.target}
    className={cn(
      'aspect-rect-vertical relative block origin-top-left overflow-hidden transition-transform duration-400 md:aspect-[1.5]',
      'md:group-[.is-next]:scale-70'
    )}
  >
    {image && (
      <Img
        data={image}
        fill
        objectCover
        className="image-hover-effect h-full w-full"
      />
    )}
    {(chipContent || title || tourInfo) && (
      <div className="absolute bottom-0 left-0 z-10 transition-opacity group-[.is-snapped]:opacity-100 max-md:w-full md:opacity-0">
        <div className="gap-gutter absolute bottom-full flex">
          <Chip>{chipContent}</Chip>
          <TourBadge
            difficulty={tourInfo?.difficulty}
            isStatusClosed={tourInfo?.isStatusClosed}
            isStatusOpen={tourInfo?.isStatusOpen}
            difficultyLabel={tourInfo?.difficultyLabel}
            framed={false}
          />
        </div>
        {(title || tourInfo) && (
          <div className="grid grid-cols-[auto_1.5rem] bg-neutral-100">
            <div>
              <Title as="h3" className="h3 pt-md pr-lg line-clamp-3 max-w-80">
                {title}
              </Title>

              <TourInfo
                distance={tourInfo?.distance}
                duration={tourInfo?.duration}
                altitudeUphill={tourInfo?.altitudeUphill}
                altitudeDownhill={tourInfo?.altitudeDownhill}
              />
            </div>
            <div className="flex items-center bg-neutral-200 text-neutral-600">
              <Icon
                icon={'material-symbols:chevron-right'}
                className="h-6 w-6"
              />
            </div>
          </div>
        )}
      </div>
    )}
  </BaseLink>
)

SectionSliderCard.displayName = 'SectionSliderCard'

export default memo(SectionSliderCard)
